
var ConnectionMessageView = function(root, parentView) {
    var self = this;

    this.parentView = parentView;
    this.root = root;

    this.root.connected.onChange("connectionView", function(connected){
        self.setMessage(connected, self.root.saved());
    });

    this.root.saved.onChange("connectionView", function(saved){
        self.setMessage(self.root.connected(), saved);
    });
    this.setMessage(this.root.connected(), this.root.saved());

    window.beforeUnloadListener = window.addEventListener("beforeunload", function (e) {
        if (self.root.saved() == false){
            var confirmationMessage = 'Do you want to reload this site? Changes you made may not be saved.';
            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        }
    });
};

module.exports = ConnectionMessageView;

ConnectionMessageView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.parentView.getTopNav().addConnectionMenu('Starting up', 'warning');
    }
    return this._template;
};


ConnectionMessageView.prototype.setMessage = function (connected, saved) {
    if (connected){
        if (saved) this.getTemplate().setConnectionMessage("Saved", "normal");
        else this.getTemplate().setConnectionMessage("Saving...", "normal");
    } else {
        if (saved) this.getTemplate().setConnectionMessage("Connection lost", "warning");
        else this.getTemplate().setConnectionMessage("Connection lost, unsaved changes", "error");
    }
};

